import { useEffect, useState } from 'react';

export interface GooglePhoto {
  file: string;
  attribution?: string | null;
  width?: number;
  height?: number;
}

interface Manifest {
  photos: { handle: string; images: GooglePhoto[] }[];
}

// Cache compartilhado do manifest (uma requisição por sessão)
let cache: Manifest | null = null;
let cachePromise: Promise<Manifest | null> | null = null;

/**
 * Retorna as fotos do Google Places de uma entidade (mesma automação da galeria).
 * Fonte: /images/google/manifest.json gerado por scripts/build/google-photos-factory.mjs.
 */
export function useGooglePhotos(handle?: string): GooglePhoto[] {
  const [images, setImages] = useState<GooglePhoto[]>([]);

  useEffect(() => {
    if (!handle) return;
    let active = true;

    const load = async () => {
      if (!cache) {
        if (!cachePromise) {
          cachePromise = fetch('/images/google/manifest.json')
            .then(r => (r.ok ? r.json() : null))
            .catch(() => null);
        }
        cache = await cachePromise;
      }
      if (!active || !cache) return;
      const entry = cache.photos?.find(p => p.handle === handle);
      setImages(entry?.images || []);
    };

    load();
    return () => {
      active = false;
    };
  }, [handle]);

  return images;
}
